var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_vm.getTerritory()),function(terr,index){return _c('li',{key:index,staticClass:"pb-1"},[_vm._v(" "+_vm._s(terr)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }